<template>
	<article class="d-error-page">
		<PageHeader
			use-wide-image
			v-bind="{
				...$attrs,
				...$props,
			}"
			:title="computedTitle"
		/>

		<BlockList
			v-if="contentElements && contentElements.length"
			class="relative mt-5xl"
			:block-list="contentElements"
		>
			<template v-if="showLongread" #aside>
				<div
					:class="[
						'pointer-events-none hidden <1024:h-5xl',
						'>=1024:block >=1024:sticky >=1024:top-6xl',
					]"
				>
					<div
						:class="[
							'w-full',
							'<1024:absolute <1024:h-full <1024:top-0',
						]"
					>
						<LongRead
							:class="[
								'z-30 <1024:mb-5xl',
								'<1024:sticky <1024:top-site-header-compact',
							]"
						/>
					</div>
				</div>
			</template>
		</BlockList>

		<div
			v-if="
				(showRelatedPages &&
					showRelatedPages.links &&
					showRelatedPages.links.length) ||
				(showMorePages &&
					showMorePages.pages &&
					showMorePages.pages.length)
			"
			class="mt-5xl space-y-5xl"
		>
			<RelatedPages
				v-if="
					showRelatedPages &&
					showRelatedPages.links &&
					showRelatedPages.links.length
				"
				v-bind="{ ...showRelatedPages, links: showRelatedPages.links }"
			/>

			<RelatedPages
				v-if="
					showMorePages &&
					showMorePages.pages &&
					showMorePages.pages.length
				"
				v-bind="{ ...showMorePages, links: showMorePages.pages }"
				grey
			/>
		</div>
	</article>
</template>

<script>
import ContentPageCustom from '~/doctypes/main/ContentPageCustom';

export default {
	name: 'MainErrorPage',

	extends: ContentPageCustom,

	inheritAttrs: false,

	props: {
		error: {
			type: Object,
			required: true,
		},
		title: String,
	},

	computed: {
		computedTitle() {
			return (
				this.title || `${this.error.statusCode} ${this.error.message}`
			);
		},
	},
};
</script>
